import { KYMW9003Component } from "./kymw9003.component";

export class KYMW9003Model {
	kymw9003Component: KYMW9003Component;

	// 検索条件
	/** 権限セット名 */
	public authoritySetName: string = <string>'';
	/** 管理者区分(0:非管理者、1:管理者、99:すべて) 
	 *  初期値 99:すべて
	*/
	public adminDiv: string = <string>'99';
	/** 権限ステータス(0:有効、1:無効、99:すべて) 
	 *  初期値 99:すべて
	*/
	public authorityStatus: string = <string>'99';

	/** 表のitemsSource */
	public authoritySetList: Array<any> = new Array<any>();
	
	/**
	 * レスポンスデータを表に表示
	 * @param serverData 
	 * 
	 */
	public updateAuthoritySetList(serverData: any): void {
		/** レスポンスのAuthoritySetList */
		const listData = serverData.AuthoritySetList;

		// 作業用配列
		const tempAuthoritySetList: Array<any> = new Array<any>();

		let authoritySetInfo: any;

		// 権限セットが取得できない場合は、空のArrayCollectionを設定する
		if (listData != null) {
			// サーバから受信したデータがArrayCollectionであれば複数データとして対応する
			if (listData instanceof Array) {
				for (let i = Number(0); i < listData.length; i++) {
					// 権限セットを生成し、作業用配列に追加
					authoritySetInfo = [];
					authoritySetInfo.authoritySetId = listData[i].AuthoritySetId;
					authoritySetInfo.authoritySetName = listData[i].AuthoritySetName;
					authoritySetInfo.adminDiv = this.nullTOEmpty(listData[i].AdminDiv);
					// 管理者区分(0:非管理者、1:管理者)
					if(authoritySetInfo.adminDiv === "1") {
						authoritySetInfo.adminDiv = "〇";
					} else {
						authoritySetInfo.adminDiv = "";
					}
					authoritySetInfo.authoritySetExplanation = this.nullTOEmpty(listData[i].AuthoritySetExplanation);
					// 権限ステータス(0:有効、1:無効)
					if (listData[i].AuthorityStatus === "0") {
						authoritySetInfo.authorityStatus = "有効";
					} else if (listData[i].AuthorityStatus === "1") {
						authoritySetInfo.authorityStatus = "無効";
					}
					tempAuthoritySetList.push(authoritySetInfo);
				}
			} else {
				// 権限セットを生成し、作業用配列に追加
				authoritySetInfo = [];
				authoritySetInfo.authoritySetId = listData[0].AuthoritySetId;
				authoritySetInfo.authoritySetName = listData[0].AuthoritySetName;
				authoritySetInfo.adminDiv = this.nullTOEmpty(listData[0].AdminDiv);
				// 管理者区分(0:非管理者、1:管理者)
				if(authoritySetInfo.adminDiv === "1") {
					authoritySetInfo.adminDiv = "〇";
				} else {
					authoritySetInfo.adminDiv = "";
				}
				authoritySetInfo.authoritySetExplanation = this.nullTOEmpty(listData[0].AuthoritySetExplanation);
				// 権限ステータス(0:有効、1:無効)
				if (listData[0].AuthorityStatus === "0") {
					authoritySetInfo.authorityStatus = "有効";
				} else if (listData[0].AuthorityStatus === "1") {
					authoritySetInfo.authorityStatus = "無効";
				}
				tempAuthoritySetList.push(authoritySetInfo);
			}
		}

    // 作業用配列をListに設定する
    this.authoritySetList = tempAuthoritySetList;
  }

	/**
   * NULLデータを表示用に空白に変換
   *
   * @private
   * @param {*} obj
   * @returns {*}
   * @memberof KYMW9000Model
   */
  private nullTOEmpty(obj: any): any {
    if (obj == null) {
      return '';
    } else if (obj === '0') {
      return '';
    } else {
      return obj;
    }
  }
}
